import ContractSummary from "./ContractSummary"

export default ContractSummary
